import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { HR } from 'foundations-components/transitional/components/HR';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { TileSection } from 'foundations-components/transitional/components/Tile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function EnterpriseManagedAuthPanel({
  statusTagUse,
  statusLabel,
  children
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(TileSection, {
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "400",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(StatusTag, {
          use: statusTagUse,
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-50",
            color: "text-core-default",
            children: statusLabel
          })
        }), children]
      })
    })]
  });
}